import { useField } from "formik";
import { IInputProps } from "../inputTypes";
import TextInput from "./TextInput";

const TextField: React.FC<IInputProps> = ({
  name,
  isError = true,
  touched,
  ...props
}) => {
  const [field, { error, touched: fieldTouched }] = useField(name);

  return (
    <TextInput
      {...props}
      {...field}
      error={error}
      touched={touched ?? fieldTouched}
      isError={isError}
    />
  );
};

export default TextField;
